export default "__VITE_ASSET__B4D5T1mW__"